import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MaterialModel} from '../models/material';
import {MaterialFormComponent} from '../components/material-form.component';

@Component({
    selector: 'app-material-dialog',
    template: `
        <div>
            <app-item-material-form (onSubmit)="closeDialog($event)" [forOrderBuild]="data.forOrderBuild"
                                    [budgetId]="data.budgetId" [subBudgetId]="data.subBudgetId" [type]="data.type"
                                    [material]="data.material"
                                    [assignPossibilities]="data.assignPossibilities"></app-item-material-form>
        </div>`,
    standalone: true,
    imports: [
        MaterialFormComponent
    ]
})
export class MaterialDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<MaterialDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {

    }

    closeDialog(mat: MaterialModel) {
        console.log('closing choose material dialog with: ', mat);
        const returned = mat.toPlainObj();
        if (mat.referencedMaterialId) {
            returned['referencedMaterialId'] = mat.referencedMaterialId;
        }
        this.dialogRef.close(returned);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }


}